import React from 'react';
import { ShipmentInfoListTemplate } from 'themes/modules/shipment-info/pages';
import { ShipmentInfoListViewStore } from 'modules/shipment-info/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new ShipmentInfoListViewStore(rootStore), 'shipmentInfoListViewStore')
class ShipmentInfoList extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <ShipmentInfoListTemplate {...this.props} viewStore={this.props.shipmentInfoListViewStore} />;
	}
}

export default ShipmentInfoList;



// WEBPACK FOOTER //
// ./src/modules/shipment-info/pages/ShipmentInfoList.jsx